import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import toast from 'react-hot-toast';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Breadcrumbs,
} from '@mui/material';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections

import { WorkOrderHead, WorkOrderToolBar } from '../sections/@dashboard/workOrder';
import StatusLabel from '../components/status';
import WoopDialogBox from '../components/woop-dialog-box';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'sl_no', label: 'Sl.No', alignRight: false },
  { id: 'projectID', label: 'Project ID', alignRight: false },
  { id: 'signType', label: 'Sign Type', alignRight: false },
  { id: 'salesPerson', label: 'Sales Person', alignRight: false },
  { id: 'WO', label: 'WO', alignRight: false },
  { id: 'releasedDate', label: 'Released Date', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'projectType', label: 'Project Type', alignRight: false },
  { id: '' },
];

const USERLIST = [
  {
    releaseDate: '8/10/2023',
    signType: 'Sign A 1.2',
    WO: 'WO-1',
    projectID: 'BRI UAE-J1-08-23',
    salesPerson: 'Sales Person 1',
    projectType: 'Projects',
    status: 'In Progress',
  },
  {
    releaseDate: '8/11/2023',
    signType: 'Sign A',
    WO: 'WO-2',
    projectID: 'BRI UAE-J1-09-23',
    salesPerson: 'Sales Person 2',
    projectType: 'Retail',
    status: 'Initiated',
  },
  {
    releaseDate: '8/11/2023',
    signType: 'Sign C 8.2',
    WO: 'WO-3',
    projectID: 'BRI UAE-J1-08-23',
    salesPerson: 'Sales Person 1',
    projectType: 'Projects',
    status: 'Yet to Plan',
  },
  {
    releaseDate: '8/12/2023',
    signType: 'Sign B 2.1',
    WO: 'WO-4',
    projectID: 'BRI UAE-J1-10-23',
    salesPerson: 'Sales Person 3',
    projectType: 'Retail',
    status: 'Completed',
  },
  {
    releaseDate: '8/13/2023',
    signType: 'Sign D 4.0',
    WO: 'WO-5',
    projectID: 'BRI UAE-J1-11-23',
    salesPerson: 'Sales Person 2',
    projectType: 'Projects',
    status: 'In Progress',
  },
  {
    releaseDate: '8/14/2023',
    signType: 'Sign A 1.2',
    WO: 'WO-6',
    projectID: 'BRI UAE-J1-12-23',
    salesPerson: 'Sales Person 1',
    projectType: 'Retail',
    status: 'Initiated',
  },
  {
    releaseDate: '8/15/2023',
    signType: 'Sign C 8.2',
    WO: 'WO-7',
    projectID: 'BRI UAE-J1-13-23',
    salesPerson: 'Sales Person 3',
    projectType: 'Projects',
    status: 'Yet to Plan',
  },
  {
    releaseDate: '8/16/2023',
    signType: 'Sign A 1.2',
    WO: 'WO-8',
    projectID: 'BRI UAE-J1-14-23',
    salesPerson: 'Sales Person 2',
    projectType: 'Retail',
    status: 'In Progress',
  },
  {
    releaseDate: '8/17/2023',
    signType: 'Sign B 2.1',
    WO: 'WO-9',
    projectID: 'BRI UAE-J1-15-23',
    salesPerson: 'Sales Person 1',
    projectType: 'Projects',
    status: 'Completed',
  },
  {
    releaseDate: '8/18/2023',
    signType: 'Sign A',
    WO: 'WO-10',
    projectID: 'BRI UAE-J1-16-23',
    salesPerson: 'Sales Person 3',
    projectType: 'Retail',
    status: 'Initiated',
  },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  let filteredArray = stabilizedThis.map((el) => el[0]);

  if (query) {
    query = query.toString().toLowerCase();
    filteredArray = filteredArray.filter((_user) => {
      // Use Object.keys to iterate over the object's own properties
      return Object.keys(_user).some((key) => _user[key].toString().toLowerCase().includes(query));
    });
  }

  return filteredArray;
}

export default function WorkOrderListPage() {
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState([]);

  const [filterPid, setFilterPid] = useState([]);


  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const handleFilterByPid = (event) => {
    setPage(0);
    setFilterPid(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;


  const [holdDialogOpen, setHoldDialogOpen] = useState(false);

  const holdHandleDialogOpen = () => {
    setHoldDialogOpen(true);
  };

  const holdHandleDialogClose = () => {
    setHoldDialogOpen(false);
  };

  const holdWorkorderHandleDialogConfirm = () => {
   // console.log('Work order Hold');
    toast.success('Workorder Successfully Placed on Hold!');
    holdHandleDialogClose();
  };

  const holdProjectHandleDialogConfirm = () => {
   // console.log('Project Hold');    
    toast.success('Project Successfully Placed on Hold!');
    holdHandleDialogClose();
  };

  

const [cancelDialogOpen, setCancelDialogOpen] = useState(false);

const cancelHandleDialogOpen = () => {
  setCancelDialogOpen(true);
};

const cancelHandleDialogClose = () => {
  setCancelDialogOpen(false);
};

const cancelWorkorderHandleDialogConfirm = () => {
 // console.log('Work order Cancel');
  toast.success('Workorder Successfully Placed on Cancel!');
  cancelHandleDialogClose();
};

const cancelProjectHandleDialogConfirm = () => {
 // console.log('Project Cancel');    
  toast.success('Project Successfully Placed on Cancel!');
  cancelHandleDialogClose();
};

  const linknav = {
    lineHeight: '1.57143',
    fontSize: '0.875rem',
    fontFamily: 'Public Sans, sans-serif',
    fontWeight: '400',
    textDecoration: 'none',
    color: 'rgb(33, 43, 54)',
  };

  const actlinknav = {
    lineHeight: '1.57143',
    fontSize: '0.875rem',
    fontFamily: 'Public Sans, sans-serif',
    fontWeight: '400',
    textDecoration: 'none',
  };

  return (
    <>
      <Helmet>
        <title> Work Order List | BRI Middleware </title>
      </Helmet>

      <Container maxWidth="100%">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <div>
            <Typography variant="h4" gutterBottom>
              Work Order List
            </Typography>
            <Breadcrumbs
              aria-label="breadcrumb"
              separator={
                <Iconify icon="ic:baseline-circle" width="6px" borderRadius="50%" color="rgb(145, 158, 171)" />
              }
            >
              <Link style={linknav} to="/dashboard">
                Dashboard
              </Link>
              <Link style={linknav} to="/machineryMaster">
                Work Order
              </Link>
              <Typography style={actlinknav} color="text.secondary">
                List
              </Typography>
            </Breadcrumbs>
          </div>
          <div>
            {/* <Button to="/createUser" color='primary' variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} component={Link}>
              New User
            </Button> */}
          </div>
        </Stack>

        <Card>
          <WorkOrderToolBar numSelected={selected.length} 
          filterName={filterName}
          filterPid={filterPid}
          onFilterName={handleFilterByName}
          onFilterPid={handleFilterByPid}/>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <WorkOrderHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={USERLIST.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                    const { id, projectID, signType, salesPerson, WO, releaseDate, status, projectType } = row;
                    const serialNumber = page * rowsPerPage + index + 1;
                    return (
                      <TableRow hover key={serialNumber} tabIndex={-1}>
                        <TableCell padding="checkbox">
                          <Typography variant="subtitle2" noWrap paddingX={2}>
                            {serialNumber}
                          </Typography>
                        </TableCell>

                        <TableCell component="th" scope="row" padding="none" style={{ Width: '10px !important' }}>
                          <Typography variant="subtitle2">{projectID}</Typography>
                        </TableCell>                        

                        <TableCell align="left">{signType}</TableCell>

                        <TableCell align="left">{salesPerson}</TableCell>

                        <TableCell align="left">{WO}</TableCell>

                        <TableCell align="left">{releaseDate}</TableCell>
                        <TableCell align="left">
                          <StatusLabel status={status} />
                        </TableCell>

                        <TableCell align="left">{projectType}</TableCell>

                        <TableCell align="right">
                          <IconButton size="large" color="inherit" onClick={handleOpenMenu}>
                            <Iconify icon={'eva:more-vertical-fill'} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={filteredUsers.length <= 5 ? [0] : [5, 10, 25]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <WoopDialogBox 
        open={holdDialogOpen}
        onClose={holdHandleDialogClose}
        onConfirm1={holdWorkorderHandleDialogConfirm}
        onConfirm2={holdProjectHandleDialogConfirm}
        btnColor1={'warning'}
        btnColor2={'error'}
        dContent={"Please confirm which action you want to place on hold?"}
        dTitle={"Confirm Hold Action"}
        btnText1={'workorder'}
        btnText2={'Project'}
      />

      <WoopDialogBox 
        open={cancelDialogOpen}
        onClose={cancelHandleDialogClose}
        onConfirm1={cancelWorkorderHandleDialogConfirm}
        onConfirm2={cancelProjectHandleDialogConfirm}
        btnColor1={'warning'}
        btnColor2={'error'}
        dContent={"Please confirm which action you want to place on cancel?"}
        dTitle={"Confirm Cancel Action"}
        btnText1={'workorder'}
        btnText2={'Project'}
      />

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <NavLink to={'/dpWoOperationPlanning'} style={{textDecoration: 'none'}}>
          <MenuItem sx={{ color: 'success.dark' }}>
            <Iconify icon={'eva:paper-plane-fill'} sx={{ mr: 2 }} />
            Plan
          </MenuItem>
        </NavLink>

        <MenuItem sx={{ color: 'warning.dark' }} onClick={holdHandleDialogOpen}>
          <Iconify icon={'eva:pause-circle-outline'} sx={{ mr: 2 }} />
          Hold
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }} onClick={cancelHandleDialogOpen}>
          <Iconify icon={'eva:close-circle-outline'} sx={{ mr: 2 }} />
          Cancel
        </MenuItem>
      </Popover>
    </>
  );
}
